import { Redirect, Stack } from "expo-router";
import { observer } from "mobx-react";
import React from "react";
import { Header } from "~/components/Header";
import { useIsNavigationReady } from "~/hooks/useIsNavigationReady";
import { useStore } from "~/mobx/utils/useStore";

const AppLayout = observer(function AppLayout() {
  const store = useStore();
  const isNavigationReady = useIsNavigationReady();

  if (isNavigationReady === false) {
    return null;
  }

  // This is a temporary code that will prevent the app from being used in production
  // until the app is ready to be used in production.
  // remove this code when the app is ready to be used in production
  // if (environment.ENVIRONMENT_NAME === "prod") {
  //   // @ts-expect-error
  //   return <Redirect href="not-found" />;
  // }

  const isLoggedIn = store.authStore.isLoggedIn;

  if (isLoggedIn === false) {
    return <Redirect href="/login" />;
  }

  return (
    <>
      <Stack
        initialRouteName="index"
        screenOptions={{
          header: (props) => <Header {...props} />,
          freezeOnBlur: false,
          animation: "slide_from_right",
        }}
      >
        <Stack.Screen
          name="index"
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="settings/index"
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="settings/contact-details"
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="my-pets/index"
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="my-pets/[id]"
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="book-appointment"
          options={{
            headerShown: false,
          }}
        />
      </Stack>
    </>
  );
});

export default AppLayout;
